import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IApplicationsState {
  showActionStageChangeRequest: boolean;
  selectedRequestId: string | null;
  showJobStageChangeRequestsModal: boolean;
  selectedJobId: string | null;
  showOfferModal: boolean;
  selectedApplicationId: string | null;
  selectedOfferId: string | null;
  showCandidateOfferModal: boolean;
  showManagerOfferActionModal: boolean;
  showNotifyCandidateOfferModal: boolean;
}

const initialState: IApplicationsState = {
  showActionStageChangeRequest: false,
  selectedRequestId: null,
  showJobStageChangeRequestsModal: false,
  selectedJobId: null,
  showOfferModal: false,
  selectedApplicationId: null,
  selectedOfferId: null,
  showCandidateOfferModal: false,
  showManagerOfferActionModal: false,
  showNotifyCandidateOfferModal: false,
};

export const applicationsSlice = createSlice({
  name: 'applications',
  initialState,
  reducers: {
    setShowActionStageRequestModal: (state, action: PayloadAction<string>) => {
      state.showActionStageChangeRequest = true;
      state.selectedRequestId = action.payload;
    },
    setHideActionStageRequestModal: (state) => {
      state.showActionStageChangeRequest = false;
      state.selectedRequestId = null;
    },
    setShowJobStageChangeRequestsModal: (state, action: PayloadAction<string>) => {
      state.showJobStageChangeRequestsModal = true;
      state.selectedJobId = action.payload;
    },
    hideJobStageChangeRequestsModal: (state) => {
      state.showJobStageChangeRequestsModal = false;
      state.selectedJobId = null;
    },
    setShowOfferModal: (
      state,
      action: PayloadAction<{ applicationId: string; offerId?: string }>
    ) => {
      state.selectedApplicationId = action.payload.applicationId;
      state.selectedOfferId = action.payload.offerId || null;
      state.showOfferModal = true;
    },
    hideOfferModal: (state) => {
      state.selectedApplicationId = null;
      state.showOfferModal = false;
      state.selectedOfferId = null;
    },
    showCandidateOfferModal: (state, action: PayloadAction<string>) => {
      state.showCandidateOfferModal = true;
      state.selectedOfferId = action.payload;
    },
    hideCandidateOfferModal: (state) => {
      state.showCandidateOfferModal = false;
      state.selectedOfferId = null;
    },
    showManagerOfferActionModal: (state, action: PayloadAction<string>) => {
      state.showManagerOfferActionModal = true;
      state.selectedOfferId = action.payload;
    },
    hideManagerOfferActionModal: (state) => {
      state.showManagerOfferActionModal = false;
      state.selectedOfferId = null;
    },
    showNotifyCandidateOfferModal: (state, action: PayloadAction<string>) => {
      state.selectedOfferId = action.payload;
      state.showNotifyCandidateOfferModal = true;
    },
    closeNotifyCandidateOfferModal: (state) => {
      state.showNotifyCandidateOfferModal = false;
      state.selectedOfferId = null;
    },
  },
});

export const {
  setShowActionStageRequestModal,
  setHideActionStageRequestModal,
  setShowJobStageChangeRequestsModal,
  hideJobStageChangeRequestsModal,
  setShowOfferModal,
  hideOfferModal,
  showCandidateOfferModal,
  hideCandidateOfferModal,

  showManagerOfferActionModal,
  hideManagerOfferActionModal,

  showNotifyCandidateOfferModal,
  closeNotifyCandidateOfferModal,
} = applicationsSlice.actions;
export default applicationsSlice.reducer;
